import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container order-refund" }
const _hoisted_2 = { class: "shop-info" }
const _hoisted_3 = { class: "flex-box" }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { class: "mt20 align-right" }

import { ref, reactive, onMounted, computed, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getAfterSaleDetailApi, saveRefundApi } from '@/apis/order'
import ImageUploaderDialog from '@/components/upload/Index.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute()

const orderId = route.query.id as string
const specId = route.query.spec_id as string
const itemIds = route.query.item_ids as string

// 状态定义
const loading = ref(false)
const submitting = ref(false)
const formRef = ref()
const orderData = ref<any>({
    data: {},
    user: {},
    items: [],
    charges: [],
    shop: {},
    logs: [],
    brand: {},
    second_list: {}
})

const formData = reactive({
    id: orderId,
    refund_type: 0,
    order_no: '',
    phone: '',
    buyer_id: '',
    created_at: '',
    pay_type: '',
    total_amount: 0,
    final_paid: 0,
    user_money_paid: 0,
    coupon_id: '',
    coupon_paid: 0,
    refund_product_amount: '',
    refund_ship: 0,
    repund_type: 0,
    bank: '',
    card: '',
    username: '',
    quit_reason: 2,
    second_quit_reason: '',
    check: 0,
    platform_bear: '',
    business_bear: '',
    repund_why: '',
    prove: [] as string[],
    note: '',
    spec_id: [] as any[],
    item_product_id: [] as any[],
    item_product_name: [] as any[],
    item_price: [] as any[],
    item_spec_name: [] as any[],
    item_quantity: [] as any[]
})

const proveFileList = ref<any[]>([])

// 校验规则
const rules = {
    repund_type: [{ required: true, message: '请选择退款方式', trigger: 'change' }],
    quit_reason: [{ required: true, message: '请选择退款原因', trigger: 'change' }],
    repund_why: [
        { required: true, message: '请输入退款说明', trigger: 'blur' },
        { min: 4, message: '退款说明至少 4 个字', trigger: 'blur' }
    ],
    bank: [{ required: true, message: '请输入银行', trigger: 'blur' }],
    card: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
    username: [{ required: true, message: '请输入用户名', trigger: 'blur' }]
}

const secondQuitReasons = computed(() => {
    const categoryMap: Record<number, string> = {
        0: 'shangjia',
        1: 'pingtai',
        2: 'kehu'
    }
    const key = categoryMap[formData.quit_reason]
    return key ? orderData.value.second_list[key] : {}
})

const initData = async () => {
    loading.value = true
    try {
        const res = await getAfterSaleDetailApi({
            order_id: orderId,
            spec_id: specId,
            item_ids: itemIds
        }) as any
        
        if (res.code == 200) {
            orderData.value = res.data
            const d = res.data.data
            const u = res.data.user
            
            // 同步到 formData
            Object.assign(formData, {
                refund_type: d.refund_type,
                order_no: d.order_no,
                phone: u.username,
                buyer_id: d.buyer_id,
                created_at: d.created_at,
                pay_type: d.pay_type,
                total_amount: d.total_amount,
                final_paid: d.final_amount,
                user_money_paid: d.total_amount,
                coupon_id: d.coupon_id,
                coupon_paid: d.coupon_paid,
                refund_product_amount: d.refund_product_amount,
                refund_ship: d.refund_ship || 0,
                repund_type: d.repund_type || 0,
                quit_reason: 2, // 默认客户原因
                second_quit_reason: d.second_quit_reason || '',
                repund_why: d.repund_why || '',
                note: d.note || '',
                spec_id: res.data.items.map((i: any) => i.spec_id),
                item_product_id: res.data.items.map((i: any) => i.product_id),
                item_product_name: res.data.items.map((i: any) => i.product_name),
                item_price: res.data.items.map((i: any) => i.price),
                item_spec_name: res.data.items.map((i: any) => i.spec_name),
                item_quantity: res.data.items.map((i: any) => i.quantity)
            })
        } else {
            ElMessage.error(res.msg || '获取数据失败')
        }
    } catch (err) {
        ElMessage.error('获取详情失败')
    } finally {
        loading.value = false
    }
}

const formatUserName = (user: any) => {
    if (!user) return ''
    return `${user.username} (姓名: ${user.name || '无'})`
}

const formatGoodsInfo = (item: any) => {
    return `${orderData.value.brand.name} 【商品】${item.product_name} 【规格】${item.spec_name} 【数量】${item.quantity}`
}

const formatChargeInfo = (charge: any) => {
    return `【附件名称】${charge.charge_name} 【数量】${charge.quantity}`
}

const formatOrderAmount = (data: any) => {
    return `总额:${data.total_amount} 余额:${data.user_money_paid} 礼券:${data.coupon_paid}`
}

const formatDeliveryInfo = (data: any) => {
    return `姓名：${data.name}\n电话：${data.phone}\n地址：${data.province} ${data.city} ${data.area} ${data.addr}\n送货时间：${data.ship_date} ${data.ship_time_text}`
}

const getStatusType = (status: number) => {
    const types: Record<number, string> = { 0: 'warning', 1: 'primary', 2: 'success', 3: 'info' }
    return types[status] || 'info'
}

const formatStatus = (status: number) => {
    const statuses: Record<number, string> = { 0: '待分配', 1: '已分配', 2: '已完成', 3: '已取消' }
    return statuses[status] || '未知'
}

const onMoneyInput = (field: 'refund_product_amount' | 'platform_bear' | 'business_bear') => {
    formData[field] = formData[field].replace(/[^0-9.]/g, '')
}

const onRefundTypeChange = (val: number) => {
    if (val !== 1) {
        formData.bank = ''
        formData.card = ''
        formData.username = ''
    }
}

const onQuitReasonChange = () => {
    formData.second_quit_reason = ''
}

const submitForm = async () => {
    await formRef.value.validate()

    if (formData.repund_why.trim().length < 4) {
        return ElMessage.warning('退款说明至少 4 个字')
    }

    if (formData.quit_reason != 3 && formData.second_quit_reason === '') {
        return ElMessage.warning('请选择退款原因')
    }

    // 承担金额校验
    const platformAmount = Number(formData.platform_bear)
    const merchantAmount = Number(formData.business_bear)
    if (platformAmount > 0 || merchantAmount > 0) {
        if (platformAmount + merchantAmount !== Number(orderData.value.data.total_amount)) {
            return ElMessage.warning('承担金额之和必须等于订单总金额')
        }
        if (formData.prove.length < 1) {
            return ElMessage.warning('请上传退款证明')
        }
    }

    try {
        await ElMessageBox.confirm('确定要执行退款操作？', '提示', { type: 'warning' })
        submitting.value = true
        const res = await saveRefundApi({
            ...formData,
            spec_id: specId,
            item_ids: itemIds
        }) as any
        if (res.code == 200 || res == 1) {
            ElMessage.success('退款成功')
            setTimeout(() => {
                window.close()
            }, 1000)
        } else {
            ElMessage.error(res.msg || '操作失败')
        }
    } catch (err) {
        if (err !== 'cancel') {
            ElMessage.error('保存失败')
        }
    } finally {
        submitting.value = false
    }
}

const goBack = () => {
    window.close()
}

onMounted(() => {
    initData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: formData,
      rules: rules,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "订单信息"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "订单号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.order_no,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderData.value.data.order_no) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "用户" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          value: formatUserName(orderData.value.user),
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "下单时间" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.created_at,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderData.value.data.created_at) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "商品信息" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.items, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_input, {
                    key: index,
                    class: "goods-item full-width",
                    value: formatGoodsInfo(item),
                    disabled: ""
                  }, null, 8, ["value"]))
                }), 128))
              ]),
              _: 1
            }),
            (orderData.value.charges?.length)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "收费附件"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderData.value.charges, (charge, index) => {
                      return (_openBlock(), _createBlock(_component_el_input, {
                        key: index,
                        class: "charge-item",
                        value: formatChargeInfo(charge),
                        disabled: ""
                      }, null, 8, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "交付方式" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(orderData.value.data.ship_type == 'shop' ? '自提' : '送货上门'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "订单金额" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          value: formatOrderAmount(orderData.value.data),
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "退款商品金额" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.refund_product_amount,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.refund_product_amount) = $event)),
                          disabled: orderData.value.data.pay_type !== 'gfpay',
                          onInput: _cache[3] || (_cache[3] = ($event: any) => (onMoneyInput('refund_product_amount')))
                        }, {
                          append: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode("元")
                          ])),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "运费" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: orderData.value.data.ship_amount,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((orderData.value.data.ship_amount) = $event)),
                          disabled: ""
                        }, {
                          append: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createTextVNode("元")
                          ])),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (orderData.value.data.repund_type != 3)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "是否退运费" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formData.refund_ship,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.refund_ship) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: 0,
                                  label: "否"
                                }),
                                _createVNode(_component_el_option, {
                                  value: 1,
                                  label: "是"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (orderData.value.data.ship_type == 'shop')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_form_item, { label: "自提时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        value: orderData.value.data.ship_date + ' ' + orderData.value.data.ship_time_text,
                        disabled: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "自提门店" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", null, "门店名称：" + _toDisplayString(orderData.value.shop?.name), 1),
                        _createElementVNode("p", null, "门店地址：" + _toDisplayString(orderData.value.shop?.address), 1),
                        _createElementVNode("p", null, "门店电话：" + _toDisplayString(orderData.value.shop?.phone), 1)
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "送货信息"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      rows: 4,
                      class: "full-width",
                      value: formatDeliveryInfo(orderData.value.data),
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "支付状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: orderData.value.data.pay_status == 1 ? 'success' : 'info'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(orderData.value.data.pay_status == 1 ? '已支付' : '未支付'), 1)
                          ]),
                          _: 1
                        }, 8, ["type"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "门店状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: orderData.value.data.shop_status == 1 ? 'success' : 'info'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(orderData.value.data.shop_status == 1 ? '已验证' : '未验证'), 1)
                          ]),
                          _: 1
                        }, 8, ["type"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "订单状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: getStatusType(orderData.value.data.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(formatStatus(orderData.value.data.status)), 1)
                          ]),
                          _: 1
                        }, 8, ["type"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "退款方式",
                      prop: "repund_type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.repund_type,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.repund_type) = $event)),
                          onChange: onRefundTypeChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "余额",
                              value: "0"
                            }),
                            _createVNode(_component_el_option, {
                              label: "银行卡",
                              value: "1"
                            }),
                            _createVNode(_component_el_option, {
                              label: "原路退回",
                              value: "2"
                            }),
                            _createVNode(_component_el_option, {
                              label: "渠道退款",
                              value: "3"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "退款原因",
                      prop: "quit_reason"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_select, {
                            modelValue: formData.quit_reason,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.quit_reason) = $event)),
                            onChange: onQuitReasonChange,
                            style: {"width":"150px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: 0,
                                label: "商家原因"
                              }),
                              _createVNode(_component_el_option, {
                                value: 1,
                                label: "平台原因"
                              }),
                              _createVNode(_component_el_option, {
                                value: 2,
                                label: "客户原因"
                              }),
                              _createVNode(_component_el_option, {
                                value: 3,
                                label: "其他"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (formData.quit_reason !== 3)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                modelValue: formData.second_quit_reason,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.second_quit_reason) = $event)),
                                filterable: "",
                                placeholder: "请选择二级原因",
                                class: "ml10",
                                style: {"width":"200px"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondQuitReasons.value, (label, value) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: value,
                                      label: label,
                                      value: value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (formData.repund_type == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "银行",
                            prop: "bank"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: formData.bank,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.bank) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "卡号",
                            prop: "card"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: formData.card,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.card) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "用户名",
                            prop: "username"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: formData.username,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.username) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "平台承担" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.platform_bear,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.platform_bear) = $event)),
                          onInput: _cache[13] || (_cache[13] = ($event: any) => (onMoneyInput('platform_bear')))
                        }, {
                          append: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode("元")
                          ])),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "商户承担" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.business_bear,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.business_bear) = $event)),
                          onInput: _cache[15] || (_cache[15] = ($event: any) => (onMoneyInput('business_bear')))
                        }, {
                          append: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createTextVNode("元")
                          ])),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商户校验",
                      prop: "check"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formData.check,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.check) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: 0 }, {
                              default: _withCtx(() => _cache[24] || (_cache[24] = [
                                _createTextVNode("需商户校验")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: 1 }, {
                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                _createTextVNode("无需商户校验")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "退款说明",
              prop: "repund_why"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 4,
                  modelValue: formData.repund_why,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.repund_why) = $event)),
                  placeholder: "退款说明至少 4 个字"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上传证明" }, {
              default: _withCtx(() => [
                _createVNode(ImageUploaderDialog, {
                  modelValue: formData.prove,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.prove) = $event)),
                  "max-count": 2,
                  accept: ".jpg,.jpeg,.png"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 3,
                  modelValue: formData.note,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.note) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_button, { onClick: goBack }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createTextVNode("取消")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                loading: submitting.value,
                onClick: submitForm
              }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createTextVNode("保存")
                ])),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          header: "操作日志",
          class: "mt20"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: orderData.value.logs,
              stripe: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "msg",
                  label: "操作内容"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "admin_name",
                  label: "操作人",
                  width: "150"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "created_at",
                  label: "操作时间",
                  width: "200"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])), [
      [_directive_loading, loading.value]
    ])
  ]))
}
}

})